import { render, staticRenderFns } from "./AddCart.vue?vue&type=template&id=6120684f&scoped=true&"
import script from "./AddCart.vue?vue&type=script&lang=js&"
export * from "./AddCart.vue?vue&type=script&lang=js&"
import style0 from "./AddCart.vue?vue&type=style&index=0&id=6120684f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120684f",
  null
  
)

export default component.exports